'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

const AllGames: React.FC<{ onClick?: () => void }> = ({
  onClick = () => {},
}) => {
  const t = useTranslations('translation')

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.text}>{t('allGames')}</div>
    </div>
  )
}

export default AllGames
